import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputPadModalComponent } from './components/input-pad-modal/input-pad-modal.component';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { FormsModule } from '@angular/forms';
import { DialogService } from './services/dialog.service';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';

@NgModule({
  declarations: [InputPadModalComponent, ConfirmModalComponent],
  entryComponents: [InputPadModalComponent, ConfirmModalComponent],
  providers: [DialogService],
  imports: [
    CommonModule,
    FomanticUIModule,
    FormsModule
  ],
  exports: []
})
export class DialogModule { }
